import { render, staticRenderFns } from "./DialogCollectTargetPriceConfirm.vue?vue&type=template&id=2805a954&scoped=true&"
import script from "./DialogCollectTargetPriceConfirm.vue?vue&type=script&lang=js&"
export * from "./DialogCollectTargetPriceConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DialogCollectTargetPriceConfirm.vue?vue&type=style&index=0&id=2805a954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805a954",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCardActions,VCardText,VDialog,VIcon})
